import { getUserInfo } from "~/api/user";
import { KEFU_LINK } from "~/utils/constants";

export const resolveUserId = data => {
	if (!data) return "";
	return data.user_id || data.uid || data.id || data.socket_uid || "";
};

export const buildKefuLink = (userId = "") => {
	if (!userId) return KEFU_LINK;
	const url = new URL(KEFU_LINK);
	url.searchParams.set("user_id", String(userId));
	return url.toString();
};

export const redirectToKefu = async () => {
	let userId = "";
	try {
		const res = await getUserInfo();
		userId = resolveUserId(res?.data);
	} catch {
		// 获取失败时仍跳转基础客服链接
	}
	window.location.href = buildKefuLink(userId);
};
